module.exports = __webpack_public_path__ + "3e2eb9a11d6c59f6a32c0a31ef2a14f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Light-Oblique.ttf
// module id = 379
// module chunks = 0